import firebase from "firebase/app";

import createContractor from "astrid-firestore/src/api/contractors/createContractor";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";

export default function AddContractorForm({ publisher, onClose }) {
	const { form, onSubmit } = useSimpleForm({
		defaultValues: {
			name: "",
			publisher,
		},
		onSubmit: (data) => createContractor(firebase, data),
		onSuccess: onClose,
	});

	return (
		<Form.Modal form={form} header="Add contractor" size="tiny" onSubmit={onSubmit} onClose={onClose}>
			<Form.Input name="name" label="Name" />
		</Form.Modal>
	);
}
